import FulfillmentStatusFilter from '../components/filters/FulfillmentStatusFilter'
import OrderDeliveryFilter from '../components/filters/OrderDeliveryFilter'
import OrderSearchFilter from '../components/filters/OrderSearchFilter'
import OrderTypeFilter from '../components/filters/OrderTypeFilter'
import PaymentStatusFilter from '../components/filters/PaymentStatusFilter'
import OrderStateFilter from '../components/filters/OrderStateFilter'
import OrderWineClubFilter from '../components/filters/OrderWineClubFilter'
import FulfillmentLocationFilter from '../components/filters/FulfillmentLocationFilter'
import {toYYYYMMDD} from 'app/format/date'
import DateRangeFilter from '../components/filters/DateRangeFilter'
import { useFeatureFlag } from 'app/features/context/FeatureFlagContext'

interface Props {
  filter: any
  onFilterChange: (filter: any) => void
  isHomePage?: boolean
}

const OrderListFilters: React.FC<Props> = ({filter, onFilterChange, isHomePage}) => {
  const handleFilterChange = (dateFilter?: any) => {
    let toDate = null,
      fromDate = null
    if (dateFilter) {
      toDate = toYYYYMMDD(dateFilter.toDate)
      fromDate = toYYYYMMDD(dateFilter.fromDate)
    }
    const newFilter = {
      ...filter,
      ...dateFilter,
      toDate,
      fromDate,
    }
    onFilterChange(newFilter)
  }
  return (
    <div className='row'>
      <div className='col-6 p-0'>
        <OrderSearchFilter filter={filter} setFilter={onFilterChange} />
      </div>
      {!isHomePage && (
        <>
          <div className='col-auto p-0 ms-2'>
            <PaymentStatusFilter filter={filter} setFilter={onFilterChange} />
          </div>

          <div className='col-auto p-0'>
            <FulfillmentStatusFilter filter={filter} setFilter={onFilterChange} />
          </div>
        </>
      )}
      <div className='col-auto mb-5 p-0'>
        <OrderDeliveryFilter filter={filter} setFilter={onFilterChange} />
      </div>
      <div className='col-auto mb-5 p-0'>
        <OrderTypeFilter filter={filter} setFilter={onFilterChange} />
      </div>
      <div className='col-auto mb-5 p-0'>
        <OrderStateFilter filter={filter} onChange={onFilterChange} />
      </div>
      <div className='col-auto mb-5 p-0'>
        {/* <OrderZipCodeFilter filter={filter} onChange={onFilterChange} /> */}
        <FulfillmentLocationFilter filter={filter} onChange={onFilterChange} />
      </div>
      {/* <div className='col-auto mb-5 p-0'>
        <OrderBottlesFilter filter={filter} onChange={onFilterChange} />
      </div>
      <div className='col-auto  mb-5 p-0'>
        <OrderWeightFilter filter={filter} onChange={onFilterChange} />
      </div> */}
      {filter.orderType === 'WINE_CLUB' && (
        <div className='col-auto  mb-5 p-0'>
          <OrderWineClubFilter filter={filter} onChange={onFilterChange} />
        </div>
      )}
      {!isHomePage && (
        <div className='col-auto mb-5 p-0'>
          <DateRangeFilter onFilterChange={handleFilterChange} _filter={filter} />
        </div>
      )}
    </div>
  )
}

export default OrderListFilters
